import {
  HelpPageAriResourceOwner,
  HelpPageAriResourceType
} from "./chunk-CRBMKFEU.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/help/page/manifest.ts
var helpPageAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: HelpPageAriResourceOwner,
  resourceType: HelpPageAriResourceType,
  resourceIdSlug: "{activationId}/{pageId}",
  resourceIdSegmentFormats: {
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    pageId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    // eslint-disable-line no-useless-escape
  }
};

// src/help/page/index.ts
var HelpPageAri = class _HelpPageAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._activationId = opts.resourceIdSegmentValues.activationId, this._pageId = opts.resourceIdSegmentValues.pageId;
  }
  get activationId() {
    return this._activationId;
  }
  get pageId() {
    return this._pageId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: helpPageAriStaticOpts.qualifier,
      platformQualifier: helpPageAriStaticOpts.platformQualifier,
      cloudId: void 0,
      resourceOwner: helpPageAriStaticOpts.resourceOwner,
      resourceType: helpPageAriStaticOpts.resourceType,
      resourceId: `${opts.activationId}/${opts.pageId}`,
      resourceIdSegmentValues: {
        activationId: opts.activationId,
        pageId: opts.pageId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, helpPageAriStaticOpts);
    return new _HelpPageAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, helpPageAriStaticOpts);
    return new _HelpPageAri(opts);
  }
  getVariables() {
    return {
      activationId: this.activationId,
      pageId: this.pageId
    };
  }
};

export {
  HelpPageAri
};
